module.exports = __webpack_public_path__ + "img/25.c7316b6a.webp";